import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from "aws-amplify";
import * as Sentry from '@sentry/browser';

import App from './app';
import * as serviceWorker from './serviceWorker';
import awsExports from "./aws-exports";

import 'bootstrap/dist/css/bootstrap.min.css';

Sentry.init({dsn: "https://1405bc26e66c46a586ef8f048d6a32a9@o374324.ingest.sentry.io/5223758"});

Amplify.configure(awsExports);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
